import script from "./Question.vue?vue&type=script&setup=true&lang=js"
export * from "./Question.vue?vue&type=script&setup=true&lang=js"

import "./Question.vue?vue&type=style&index=0&id=5497172e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5497172e"]])

export default __exports__